package uz.ferro.erp.util

import uz.ferro.erp.locale.Language
import uz.ferro.erp.locale.LanguageManager
import uz.ferro.erp.model.DictItem

fun DictItem?.localized(): String {
    this ?: return ""
    return when (LanguageManager.currentLanguage) {
        Language.UZ_LAT -> textUzLat
        Language.UZ_CYR -> textUzCyr
        Language.RU -> textRu
        Language.EN -> textEn
    }.onBlank(textDefault)
}

fun DictItem?.matchSearch(query: String): Boolean {
    this ?: return false
    return textDefault.containsLowercase(query) ||
            textUzLat.containsLowercase(query) ||
            textUzCyr.containsLowercase(query) ||
            textRu.containsLowercase(query) ||
            textEn.containsLowercase(query)
}

private fun String?.containsLowercase(query: String): Boolean {
    this ?: return false
    return this.lowercase().contains(query.lowercase())
}